import gql from 'graphql-tag';
import { TAG_FRAGMENT } from '../../fragments/tag.fragment';

export const QUERY_BOOKS_TABLE = gql`
  query booksTable {
    books {
      id
      ISBN
      year
      authors {
        name
      }
      content {
        title
        language
      }
      tags {
        ...TagData
      }
    }
  }
  ${TAG_FRAGMENT}
`;
